/**
 * An outbound message's delivery record, as the API serves it (opaque in the
 * schema). `error` is the provider's own reason when the send failed, such as
 * Meta's "131042 Business eligibility payment issue" (#1488): without it on
 * screen a manager only sees « Failed » and cannot tell a billing setting
 * from a bad number.
 */
export type MessageDelivery = { status?: string; error?: string }

export function messageDelivery(message: unknown): MessageDelivery {
    const raw = (message as { delivery?: unknown } | null)?.delivery
    if (!raw || typeof raw !== 'object') return {}
    const { status, error } = raw as Record<string, unknown>
    return {
        status: typeof status === 'string' && status ? status : undefined,
        // The reason only matters once the send has failed: a stale error
        // left on a record later marked delivered is not shown.
        error: status === 'failed' && typeof error === 'string' && error ? error : undefined,
    }
}
